// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"4d5ce915","140":"83da3d58","152":"063ccba9","200":"53a96cb1","344":"400d1dfc","407":"85d8a3da","468":"f7062605","568":"f39a4a7f","680":"a5a087ff","788":"88c3c81e","920":"a5ab78ee","924":"3b9e5a0b","940":"408bfe04","968":"76aa1b63"}[chunkId] + ".chunk.js";
};